<template>
    <layout-authenticated>
        <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
        <h1 class="mb-3">{{ $t('buyers.buyers') }}</h1>
        <buyers-table v-if="warehouseId !== null" :warehouse-id="warehouseId"/>
    </layout-authenticated>
</template>

<script>
import LayoutAuthenticated from '@/layouts/LayoutAuthenticated';
import BuyersTable from "@/components/user/buyers/BuyersTable";
import snackbarMixin from "@/mixins/SnackbarMixin";
import _ from "lodash";

export default {
    name: "Buyers",
    mixins: [snackbarMixin],
    components: {BuyersTable, LayoutAuthenticated},
    computed: {
        breadcrumb() {
            return [
                {
                    text: this.$t('app.name'),
                    href: '/'
                },
                {
                    text: this.$t('buyers.buyers'),
                    href: '/buyers',
                    disabled: true
                }
            ];
        },
        userId() {
            return this.$store.getters['identity/getUserId'];
        },
        warehouseId() {
            let warehouseId = _.toInteger(this.$store.getters['warehouse/getWarehouseId'](this.userId));
            if (warehouseId === null) {
                this.snackbarError(this.$t('snackbar.warehouses.not_selected'));
                return null;
            }
            return warehouseId;
        }
    }
}
</script>
